<template>
    <div class="text-xs-left">
        <fieldset>
            <legend>Hide Image from Role Selected: </legend>
            <v-chip :color="color(item)" v-for="item in allRoles" :key="item"
                @click="statusChanged(item)">
                <v-avatar v-show="roleSelected(item)">
                    <v-icon>check_circle_outline</v-icon>
                </v-avatar>
                <v-avatar v-show="!roleSelected(item)">
                    <v-icon>radio_button_unchecked</v-icon>
                </v-avatar>
                {{item}}
            </v-chip>
        </fieldset>
        <div class="v-label v-label--active theme--light"></div>


        <!-- {{hideFromRoles}} -->
    </div>
    
</template>
<script>
import {mapActions} from 'vuex'

export default {
    props: ['imageData', 'allRoles'],
    data() {
        return {}
    },
    computed: {
        hideFromRoles() {
            return this.imageData.hideFromRoles
        }
    },
    methods: {
        ...mapActions('adminItemImages', [
            'updateItemImageHidenRoles'
        ]),
        roleSelected(roleId) {
            return !this.hideFromRoles? false :
                this.hideFromRoles.findIndex(item=>item == roleId) >= 0
        },
        color(item) {
            return this.roleSelected(item)? 'green' : ''
        },
        async statusChanged(roleId) {
            let tempRolesClone = [...this.hideFromRoles]
            if(this.roleSelected(roleId)) {
                //remove
                tempRolesClone = tempRolesClone.filter(item => item != roleId)
            }
            else {
                //add
                tempRolesClone = [...tempRolesClone, roleId]

            }

            var payload = {
                imgId: this.imageData.id,
                hideFromRoles: tempRolesClone
            }

            await this.updateItemImageHidenRoles(payload)
            
            this.$emit('rolesChanged', tempRolesClone)
        }
    },
}
</script>